// Action Types
// const env = window.env || {};
export const FETCH_ALL_EHR_REQUEST = 'FETCH_ALL_EHR_REQUEST';
export const FETCH_ALL_EHR_SUCCESS = 'FETCH_ALL_EHR_SUCCESS';
export const FETCH_ALL_EHR_FAILURE = 'FETCH_ALL_EHR_FAILURE';


// Action Creators
export const fetchAllEhrRequest = () => ({
    type: FETCH_ALL_EHR_REQUEST
});

export const fetchAllEhrSuccess = (data) => ({
    type: FETCH_ALL_EHR_SUCCESS,
    payload: data
});

export const fetchAllEhrFailure = (error) => ({
    type: FETCH_ALL_EHR_FAILURE,
    payload: error
});

export const fetchTotalRecord = (
    cwOrgId,
    ssn,
    npi,
    orgName,
    email,
    profileId
) => async (dispatch) => {
    try {
        dispatch(fetchAllEhrRequest());

        const payload = {
            subjectId: cwOrgId,
            value: ssn,
            npi: npi,
            orgName: orgName,
            status: "current",
            providerName: "Anu P",
            email,
            profileId: profileId
        };

        console.log("Payload:", payload);

        const response = await fetch("https://healthdata.api.calciumhealth.com/ehrSummaryget", {
        // const response = await fetch("https://hc-platform-node-func-prod-03.azurewebsites.net/api/GetPDF?code=zYcXZaeNh0gb9UOaioV3oiLYf4D7BlNpj7Ca8E4agwrrwKttnqXPow==", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        console.log(data);

        if (data) {
            dispatch(fetchAllEhrSuccess({ data }));
        } else {
            dispatch(fetchAllEhrSuccess([]));
        }
    } catch (error) {
        console.error("Error fetching total record:", error);
        dispatch(fetchAllEhrFailure(error.message));
    }
};


// export const fetchTotalRecord = (email, ssn) => async (dispatch) => {
//     try {
//         dispatch(fetchAllEhrRequest());
//         const payload = {
//             subjectId: "2.16.840.1.113883.3.10187.1",
//             value: ssn,
//             npi: "1407571664",
//             orgName: "Titan Medical Associates",
//             status: "current",
//             providerName: "Anu P",
//             email
//         };

//         console.log("Payload:", payload);


//         const response = await fetch(`${env.API_ROOT_PROFILES}/organizations/ehrget`, {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(payload)
//         });
//         // const response = await fetch(`${apiRoot}/GetPDF?code=${apiKey}`, {
//         //     method: "POST",
//         //     headers: {
//         //         'Content-Type': 'application/json'
//         //     },
//         //     body: JSON.stringify(payload)
//         // });

//         const data = await response.json();
//         dispatch(fetchAllEhrSuccess({ data }));
//         console.log(data);

//         if (data) {
//             dispatch(fetchAllEhrSuccess({ data }));
//         } else {
//             dispatch(fetchAllEhrSuccess([]));
//         }
//     } catch (error) {
//         console.error("Error fetching total record:", error);
//         dispatch(fetchAllEhrFailure(error.message));
//     }
// };


